var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('room-container',{ref:"TUIRoomRef",on:{"on-log-out":_vm.handleLogOut,"on-create-room":_vm.onCreateRoom,"on-enter-room":_vm.onEnterRoom,"on-exit-room":_vm.onExitRoom,"on-destroy-room":_vm.onDestroyRoom,"on-kick-off":_vm.onKickOff}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }